import React from 'react';
import { some, find, startsWith, head } from 'lodash';
import PropTypes from 'prop-types';
import { findClosestMsrp } from '../findClosestMsrp';
import EngineTransmissionOption from './engineTransmissionOption/EngineTransmissionOption';
import TrimOption from './trimOption/TrimOption';
import TrimCardImage from './TrimCardImage/TrimCardImage';
import GridCard, {
  GridCardPrimarySection,
} from '../../../components/cards/gridCard/GridCard';
import { useModelInfo } from '../../../common/ModelInfoContext';
import PriceWithDisclaimer from '../priceWithDisclaimer/PriceWithDisclaimer';

const TrimCard = (props) => {
  const {
    trim,
    selections,
    disclaimer,
    msrp,
    onChange,
    isSelectionRevealed,
    cardIndex,
    displayOnlyLabel,
    isUpdating,
    isUpdatingOption,
    wait,
    animation,
    enablePopConsTrimFilters = false,
    readOnly = false,
    isFiltered = false,
    primaryRef,
    primaryDivHeight,
  } = props;

  const { trimName, highlights, options, msrp: trimMsrp } = trim;
  const { isEvMode } = useModelInfo();
  const option =
    find(options, {
      engineCode: selections.engine,
      transmissionCode: selections.transmission,
    }) || findClosestMsrp(options, msrp);

  const ANALYTICS_KEY = 'trims';
  const ANALYTICS_KEY_2 = `${option?.trimName} ${option?.driveType}`;

  const isTrimSelected = enablePopConsTrimFilters
    ? isSelectionRevealed &&
      some(options, {
        styleId: selections.styleId,
        engineCode: selections.engine,
      })
    : isSelectionRevealed && some(options, { styleId: selections.styleId });

  const hideRadioButtonCircle = options.length === 1;

  const onTrimChange = () => {
    const defaultOption = isSelectionRevealed ? option : options[0];
    onChange(defaultOption);
  };

  const cgiUrl = trim.cgi;

  return (
    <GridCard
      checked={isTrimSelected}
      onClick={!readOnly ? onTrimChange : null}
      isUpdating={isUpdating}
      isUpdatingOption={isUpdatingOption}
      wait={wait}
      animation={animation}>
      <div
        className="stat-wrapper trim-card__primaary-container"
        ref={primaryRef}
        style={primaryDivHeight ? { height: `${primaryDivHeight}px` } : {}}
        data-dtm={ANALYTICS_KEY}
        data-dtm2={ANALYTICS_KEY_2}>
        <div>
          <TrimCardImage cgi={cgiUrl} trimName={trimName} />
          {option.subHeader && (
            <div className="trim-card__image--subheader">
              {option.subHeader}
            </div>
          )}
        </div>
        <GridCardPrimarySection>
          <TrimOption
            isFiltered={isFiltered}
            trim={trim}
            option={option}
            checked={isTrimSelected}
            cardIndex={cardIndex}
            displayOnlyLabel={displayOnlyLabel}
            highlight={head(highlights)}
            analyticsKey={`${ANALYTICS_KEY}`}
            isEvMode={isEvMode}
          />
        </GridCardPrimarySection>
      </div>
      {isEvMode ? (
        <>
          {trimMsrp && (
            <div className="trim-card__price-container">
              <PriceWithDisclaimer
                message={trimMsrp.unknown}
                value={trimMsrp.amount?.value}
                disclaimer={disclaimer}
                useModal
              />
            </div>
          )}
        </>
      ) : (
        <div className="trim__engine-transmission-list">
          {options.map((option, index) => (
            <EngineTransmissionOption
              key={index}
              index={index}
              option={option}
              checked={
                isTrimSelected &&
                startsWith(option.engine.code, selections.engine) &&
                startsWith(option.transmission.code, selections.transmission)
              }
              disclaimer={disclaimer}
              onChange={!readOnly ? onChange : null}
              hideRadioButtonCircle={hideRadioButtonCircle}
              analyticsKey={`${ANALYTICS_KEY}:${trimName}`}
            />
          ))}
        </div>
      )}
    </GridCard>
  );
};

TrimCard.propTypes = {
  trim: PropTypes.object.isRequired,
  selections: PropTypes.object.isRequired,
  disclaimer: PropTypes.string,
  analyticsKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isSelectionRevealed: PropTypes.bool,
};

export default TrimCard;
